/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2022 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers.  The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { CustomAppState } from "@eisinc/App/Store/Reducers";
import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import { HasShellContext, withIsInShell } from "@insite/client-framework/Components/IsInShell";
import Zone from "@insite/client-framework/Components/Zone";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import Page from "@insite/mobius/Page";
import Typography from "@insite/mobius/Typography";
import parse from "html-react-parser";
import * as React from "react";
import { connect } from "react-redux";

const mapStateToProps = (state: CustomAppState) => ({
    error: state.xError.message,
});

type OwnProps = ReturnType<typeof mapStateToProps> & PageProps & HasShellContext;

const UnhandledErrorModal = ({ id, fields, shellContext: { isCurrentPage, isInShell }, error }: OwnProps) => {
    return (
        <Page>
            {isCurrentPage && isInShell && (
                // we can't use the PageTitle widget because it will always show the title of the current page. That would work in the shell, but not when the modal displays in the real world
                <Typography variant="h2" as="h1">
                    {fields["modalTitle"]}
                </Typography>
            )}
            {error && <Typography variant="p">{parse(error,parserOptions)}</Typography>}
            <Zone contentId={id} zoneName="Content" />
        </Page>
    );
};

const pageModule: PageModule = {
    component: connect(mapStateToProps)(withIsInShell(UnhandledErrorModal)),
    definition: {
        hasEditableTitle: false,
        hasEditableUrlSegment: false,
        pageType: "System",
        fieldDefinitions: [
            {
                name: "modalTitle",
                displayName: "Modal Title",
                editorTemplate: "TextField",
                defaultValue: "Unhandled Error",
                fieldType: "Translatable",
                isRequired: true,
                sortOrder: 0,
            },
        ],
    },
};

export default pageModule;
